export const generateMonthRange = () => {
  let months = [];
  for (let i = 1; i <= 24; i++) {
    months.push(i.toString());
  }
  return months;
};
